export default __webpack_public_path__ + "static/media/affligem_l1.724010c6.png";